import { z } from "zod";
import { richTextBlockDtoSchema } from "./rich-text-block.schema";
export const farmAdviceSolutionDtoSchema = z.object({
    id: z.string(),
    title: z.string(),
    content: z.array(richTextBlockDtoSchema),
});
//# sourceMappingURL=farm-advice-solution.schema.js.map